import React, { useEffect } from "react";

export default ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return <h5 className="vh-100 flex-center pb-9">Redirecting...</h5>;
};
